import React from 'react';

import EditIcon from 'Assets/icons/edit.svg';

export default function GeneralRiskImpactsTableRow(props) {
    return (
        <tr>
            <td className="tw-align-top inbud-numeric-cell">{props.impact.rank}</td>
            <td className="tw-align-top">{props.impact.mark}</td>
            <td onClick={props.onEdit}>{props.impact.description}</td>
            <td>
                <button type="button" className="tw-flex tw-items-center tw-gap-x-1.5 tw-text-sm tw-font-semibold tw-text-blue" onClick={props.onEdit}>
                    <EditIcon className="tw-h-3" />
                    <div>{$t('Edit')}</div>
                </button>
            </td>
        </tr>
    );
}
